import { render, staticRenderFns } from "./DocSpace.vue?vue&type=template&id=a262f876&"
import script from "./DocSpace.vue?vue&type=script&lang=js&"
export * from "./DocSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports